import { useNavigate } from 'react-router-dom';
import { Text, BlockStack, Button } from '@shopify/polaris';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '40px',
        backgroundColor: '#f6f6f7',
      }}
    >
      <BlockStack gap="400">
        <div style={{ textAlign: 'center' }}>
          {/* Logo */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              marginBottom: '32px',
            }}
          >
            <div
              style={{
                width: '48px',
                height: '48px',
                background:
                  'linear-gradient(135deg, #ff6b6b 0%, #feca57 50%, #48dbfb 100%)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span style={{ color: 'white', fontWeight: 'bold', fontSize: '24px' }}>A</span>
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Text as="span" variant="heading3xl">
            404
          </Text>
        </div>

        <div style={{ textAlign: 'center' }}>
          <Text as="h1" variant="headingXl" fontWeight="bold">
            Page Not Found
          </Text>
        </div>

        <div style={{ textAlign: 'center', maxWidth: '400px' }}>
          <Text as="p" tone="subdued">
            The page you're looking for doesn't exist or has been moved. Let's get you back on
            track.
          </Text>
        </div>

        <div style={{ textAlign: 'center', marginTop: '16px' }}>
          <Button variant="primary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </div>

        <div style={{ textAlign: 'center', marginTop: '8px' }}>
          <Button variant="plain" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </div>
      </BlockStack>
    </div>
  );
}
